import "./animations.js";
import "./_mega-menu.js";
import "./deferred-asset.js";
import "./delayed-script.js";
import "./_media.js";
import "./_modal.js";
import "./_slider.js";
import { callOnReady, initAnchor } from "./gw.js";
import "./details-disclosure.js";
import "./elements.js";
import "./parsed-element.js";
import "./shopify-utils.js";
import "./deferred-import.js";
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }

  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }

  function processPreload(link) {
    if (link.ep) return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
window.remBase = Number.parseInt(
  getComputedStyle(document.documentElement).getPropertyValue("font-size"),
  10,
);
if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1",
    );
}
callOnReady(() =>
  document
    .querySelectorAll(`a[href^="#"], a[href^="${window.location.pathname}#"]`)
    .forEach(initAnchor),
);
